import { SxProps, Theme } from '@mui/material/styles';

export const SX_BOX: SxProps<Theme> = {
  display: { lg: 'none', xs: 'flex' },
  flexGrow: 0,
};

export const SX_MENU: SxProps<Theme> = {
  display: { lg: 'none', xs: 'block' },
};

export const SX_PAPER: SxProps<Theme> = {
  '.MuiMenuItem-root:hover': {
    backgroundColor: 'transparent',
  },
  backgroundColor: 'var(--bg-mobile-menu)',
  backgroundImage: 'none',
  borderRadius: 0,
  boxShadow: '0 0 64px var(--nav-shadow)',
  height: 'auto',
  left: 0,
  maxHeight: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
  position: 'fixed',
  top: 0,
  transformOrigin: '0px 0px',
  transition: 'var(--transition-ease-out-250)',
  width: '100%',
};

export const SX_MENU_ITEM: SxProps<Theme> = {
  height: 'var(--logo-m)',
  marginBottom: 'calc(var(--logo) - var(--logo-m))',
};
